import {useCallback, useMemo} from 'react';
import {Dropzone} from '../components/Dropzone';
import {UploadQueue} from '../components/UploadQueue';
import {useTestUploadQueue} from '../api/testUpload';
import {useWakeLock} from '../lib/useWakeLock';

// TEMP: публічна сторінка без авторизації. Заливає файли у спільну папку
// UploaderRoot/TEST на Drive. Зробити дзеркалом основного флоу немає сенсу
// (немає юзера, немає анкети) — просто Dropzone + список прогресу.
export function TestUpload() {
  const queue = useTestUploadQueue();

  const onDrop = useCallback((accepted: File[]) => queue.enqueue(accepted), [queue]);

  const hasUploadsInFlight = useMemo(
    () => queue.items.some((i) => i.status === 'queued' || i.status === 'uploading'),
    [queue.items],
  );

  useWakeLock(hasUploadsInFlight);

  return (
    <div className="min-h-screen p-4 sm:p-6">
      <div className="max-w-3xl mx-auto space-y-8">
        <header className="space-y-1">
          <h1 className="text-xl sm:text-2xl font-semibold">Тестовая загрузка</h1>
          <p className="text-sm text-slate-500">
            Открытая страница без авторизации — все файлы попадают в общую папку
            <span className="font-medium text-slate-700"> TEST</span>.
          </p>
        </header>

        <Dropzone onDrop={onDrop} />

        <UploadQueue items={queue.items} onCancel={queue.cancel} onRetry={queue.retry} />
      </div>
    </div>
  );
}
